/** @hidden */
export var internalZoomFactorChange = 'internalZoomFactorChange';
/** @hidden */
export var contentChangeEvent = 'contentChange';
/** @hidden */
export var documentChangeEvent = 'documentChange';
/** @hidden */
export var selectionChangeEvent = 'selectionChange';
/** @hidden */
export var zoomFactorChangeEvent = 'zoomFactorChange';
/** @hidden */
export var beforeFieldFillEvent = 'beforeFieldFill';
/** @hidden */
export var afterFieldFillEvent = 'afterFieldFill';
/** @hidden */
export var afterFormFieldFillEvent = 'afterFormFieldFill';
/** @hidden */
export var beforeFormFieldFillEvent = 'beforeFormFieldFill';
/** @hidden */
export var serviceFailureEvent = 'serviceFailure';
/** @hidden */
export var viewChangeEvent = 'viewChange';
/** @hidden */
export var customContextMenuSelectEvent = 'customContextMenuSelect';
/** @hidden */
export var customContextMenuBeforeOpenEvent = 'customContextMenuBeforeOpen';
/** @hidden */
export var contentControlEvent = 'contentControl';
/** @hidden */
export var commentBeginEvent = 'commentBegin';
/** @hidden */
export var commentEndEvent = 'commentEnd';
/** @hidden */
export var beforeCommentActionEvent = 'beforeCommentAction';
/** @hidden */
export var commentDeleteEvent = 'commentDelete';
/** @hidden */
export var revisionActionEvent = 'beforeAcceptRejectChanges';
/** @hidden */
export var beforePaneSwitchEvent = 'beforePaneSwitch';
/** @hidden */
export var requestNavigateEvent = 'requestNavigate';
/** @hidden */
export var actionCompleteEvent = 'actionComplete';
/** @hidden */
export var trackChangeEvent = 'trackChange';
/** @hidden */
export var searchResultsChangeEvent = 'searchResultsChange';
/** @hidden */
export var keyDownEvent = 'keyDown';
/** @hidden */
export var toolbarClickEvent = 'toolbarClick';
/** @hidden */
export var beforeFileOpenEvent = 'beforeFileOpen';
/** @hidden */
export var internalviewChangeEvent = 'internalviewChange';
/** @hidden */
export var beforeXmlHttpRequestSend = 'beforeXmlHttpRequestSend';
/** @hidden */
export var protectionTypeChangeEvent = 'protectionTypeChange';
/** @hidden */
export var internalDocumentEditorSettingsChange = 'internalDocumentEditorSettingsChange';
/** @hidden */
export var internalStyleCollectionChange = 'internalStyleCollectionChange';
/** @hidden */
export var defaultFont = 'Times New Roman';
/** @hidden */
export var internalAutoResize = 'internalAutoResize';
/** @hidden */
export var beforeAutoResize = 'beforeAutoResize';
